import { CallbackObject } from 'api/core/get-page-function';
import { instance } from 'api/core';

export const assignPreparationAreaToCircuit = async (
    circuitId: string,
    preparationAreaId: string,
    callback: CallbackObject<void>
) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    try {
        await instance.patch(`/picking/circuits/${circuitId}/preparation-area/${preparationAreaId}`, {}, config);
        callback.success();
    } catch (err) {
        if (callback.error) callback.error(err);
    }
};
